import { render, staticRenderFns } from "./FoodServiceBrands.vue?vue&type=template&id=2e84b672&scoped=true&"
import script from "./FoodServiceBrands.vue?vue&type=script&lang=js&"
export * from "./FoodServiceBrands.vue?vue&type=script&lang=js&"
import style0 from "./FoodServiceBrands.vue?vue&type=style&index=0&id=2e84b672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e84b672",
  null
  
)

export default component.exports